import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },

  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const MFSBeneficiaryAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');

  const [mobileNumber, setMobileNumber] = useState('');
  const [recipientName, setRecipientName] = useState('');

  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const [mfsObj, setMfsObj] = useState({});
  const [mfsId, setMfsId] = useState('');
  const [mfsList, setMfsList] = useState([]);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const validation = () => {
    let isError = false;
    if (!mfsId.trim()) {
      console.log('mfsId');
      handleSnakbarOpen('Please select MFS name', 'error');
      document.getElementById('mfsId').focus();
      return (isError = true);
    }
    if (!recipientName.trim()) {
      handleSnakbarOpen('Please enter recipient name', 'error');
      document.getElementById('recipientName').focus();
      return (isError = true);
    }
    if (!mobileNumber.trim()) {
      console.log('mobileNumber');
      handleSnakbarOpen('Please enter mobile number', 'error');
      document.getElementById('mobileNumber').focus();
      return (isError = true);
    }

    console.log('finish');
    return isError;
  };

  const handleChange = event => {
    console.log(event.target.value);
    setMfsId(event.target.value);
  };
  const handleMfsObj = item => {
    console.log('item', item);
    setMfsObj(item);
  };
  const getMFS = async () => {
    await axios
      .get(`/api/v1/public/mfs`)
      .then(function(response) {
        console.log('response', response);
        setMfsList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
  const clearStates = () => {
    setId('');
    setMfsId('');
    setMobileNumber('');
    setRecipientName('');
    setMfsObj({});
    setStatus(false);
    setEditObj({});
  };

  const onSubmit = async e => {
    console.log('onSubmit');
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();

    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);
      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/beneficiary/${userId}/mfs`,
            method: 'post',
            data: { mfsId, mobileNumber, recipientName, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('addForm Submit', mfsId, mobileNumber, recipientName, status);
          let resObject = response.data.data;
          let newObject = {
            id: resObject.id,
            mfs: mfsObj,
            mobileNumber: resObject.mobileNumber,
            recipientName: resObject.recipientName,
            status: resObject.status,
            'new entry': '',
          };
          setList([...list, newObject]);
          clearStates();
          console.log('addForm response', response);
        } else if (editForm) {
          // response = await axios({
          //   url: `/api/v1/private/beneficiary/${userId}/cashpickup/${id}`,
          //   method: 'put',
          //   data: { mfsId, mobileNumber, recipientName, status },
          //   headers: {
          //     Authorization: `Bearer ${token}`,
          //   },
          // });
          // console.log('editForm Submit', id, mfsId, mobileNumber, recipientName, status);
          //===============for now start===================

          setLoading(false);
          return;
          //===============for now end===================
        }

        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        setLoading(false);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      }
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    if (editObj.id) {
      console.log('editObj', editObj);

      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);

      setMfsId(editObj.mfs.id);
      setMobileNumber(editObj.mobileNumber);
      setRecipientName(editObj.recipientName);

      setStatus(editObj.status);
    }
  }, [editObj]);

  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };
  useEffect(() => {
    getMFS();
  }, []);

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update MFS Beneficiary' : 'Add MFS Beneficiary'}
        </Typography>
      </div> */}
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update MFS Beneficiary' : 'Add MFS Beneficiary'}
        </Typography>
      </div>

      <FormControl variant="outlined" fullWidth size="small" className={`${classes.marginStyle} ${classes.selectStyle}`}>
        <InputLabel id="demo-simple-select-outlined-label">Select MFS</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="mfsId"
          value={mfsId}
          onChange={handleChange}
          label="Select MFS">
          {mfsList &&
            mfsList.map((item, i) => (
              <MenuItem key={i} value={item.id} onClick={() => handleMfsObj(item)}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <TextField
        id="recipientName"
        label="Recipient Name"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={recipientName}
        onChange={e => setRecipientName(e.target.value)}
      />
      <TextField
        id="mobileNumber"
        label="Mobile Number"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={mobileNumber}
        onChange={e => setMobileNumber(e.target.value)}
      />

      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>
      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained" color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div> */}

      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default MFSBeneficiaryAddEdit;
